export default __webpack_public_path__ + "static/media/savoir-faire.e28060c2.jpg";